import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Cookies from 'js-cookie';
import enTranslation from './locales/en.json';
import deTranslation from './locales/de.json';

const resources = {
  en: {
    translation: enTranslation,
  },
  de: {
    translation: deTranslation,
  },
};

// German is the base language of the panel: it is what a user sees before
// picking anything, and what any missing key falls back to.
i18n.use(initReactI18next).init({
  resources,
  lng: Cookies.get('currentLang') || 'de',
  fallbackLng: 'de',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;

// hook path test
